import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { useAnalytics } from "@/hooks/useAnalytics";
import AnalyticsDebugPanel from "@/components/debug/AnalyticsDebugPanel";
import ErrorBoundary from "@/components/ErrorBoundary";

// Lazy load all pages for code-splitting
const IndexV3 = lazy(() => import("./pages/IndexV3"));
const AvisoPrivacidad = lazy(() => import("./pages/AvisoPrivacidad"));
const TerminosCondiciones = lazy(() => import("./pages/TerminosCondiciones"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminUsers = lazy(() => import("./pages/AdminUsers"));
const AdminAnalytics = lazy(() => import("./pages/AdminAnalytics"));
const BulkEmail = lazy(() => import("./pages/BulkEmail"));
const PreselectionEmail = lazy(() => import("./pages/PreselectionEmail"));
const Auth = lazy(() => import("./pages/Auth"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const FormDesigns = lazy(() => import("./pages/FormDesigns"));

const queryClient = new QueryClient();

const AnalyticsBootstrap = () => {
  useAnalytics();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AnalyticsBootstrap />
          <AnalyticsDebugPanel />
          <ErrorBoundary componentName="AppRoot">
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                <Route path="/" element={<IndexV3 />} />
                <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
                <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/masivo" element={<BulkEmail />} />
              <Route path="/preseleccion" element={<PreselectionEmail />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/opciones" element={<FormDesigns />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </Suspense>
          </ErrorBoundary>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
